import React, { memo, useCallback, useState } from 'react';
import { AUTO_SELECT_TAB_LOGIC_SETTING, AUTO_SELECT_TAB_SIMULATION } from 'shared-modules/constants';
import {
  useOmakasePlanSimulationChart,
  useOmakasePlanStrategies,
} from 'shared-modules/services/hooks/omakasePlanLogic';
import { useDispatch } from 'react-redux';
import {
  OMAKASE_PLAN_REQUIRED_MARGIN_TEXT,
  OMAKASE_PLAN_REQUIRED_MARGIN_TOOLTIP,
} from 'shared-modules/constants/omakasePlan';
import { Button, Tabs } from '../../../../../components';
import styles from './detail.module.scss';
import Simulation from './Simulation';
import LogicSetting from './LogicSetting';
import { MarginText } from '../../../../../components/Texts';
import { openOmakaseConfirmModal } from '../../../../../redux/actions/modalActions';
import { InfoTooltip } from '../../../../../components/InfoTooltip';

const TAB_ITEMS = [
  {
    id: AUTO_SELECT_TAB_SIMULATION,
    label: 'シミュレーション',
    children: <Simulation />,
  },
  {
    id: AUTO_SELECT_TAB_LOGIC_SETTING,
    label: 'ロジック設定',
    children: <LogicSetting />,
  },
];

const Detail = () => {
  const [activeTab, setActiveTab] = useState(AUTO_SELECT_TAB_SIMULATION);
  const dispatch = useDispatch();
  const { simulationData } = useOmakasePlanSimulationChart();
  const { nextBtn } = useOmakasePlanStrategies();

  const handleClick = useCallback(() => {
    dispatch(openOmakaseConfirmModal());
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <div className={styles.tabArea}>
        <Tabs
          containerClassName={styles.tabContainer}
          tabMinWidth={160}
          items={TAB_ITEMS}
          activeKey={activeTab}
          onChange={setActiveTab}
        />
      </div>
      <div className={styles.footerContainer}>
        <div className={styles.recommendMarginText}>
          <div className={styles.label}>
            {OMAKASE_PLAN_REQUIRED_MARGIN_TEXT}
            <InfoTooltip className={styles.noPadding} message={OMAKASE_PLAN_REQUIRED_MARGIN_TOOLTIP} />
          </div>
          <MarginText
            value={simulationData.marginRequired}
            className={styles.marginText}
            symbolClassName={styles.unitText}
          />
        </div>
        <Button green width={176} className={styles.confirmButton} disabled={nextBtn.isDisabled} onClick={handleClick}>
          {nextBtn.label}
        </Button>
      </div>
    </div>
  );
};

export default memo(Detail);
